const KEY = 'deviceId'

// Id persistente do navegador/perfil (não do hardware — browsers não expõem
// isso por privacidade). Gerado uma vez e reaproveitado em todo login futuro
// nesse mesmo navegador; amarra o token da sessão a ele (ver verifyToken.js).
export default function getDeviceId() {
    let id = localStorage.getItem(KEY)
    if (!id) {
        id = crypto.randomUUID()
        localStorage.setItem(KEY, id)
    }
    return id
}
